import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const ThemeContext = createContext({ theme: "light", setTheme: () => {} });

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => {
    const cached = typeof window !== "undefined" ? localStorage.getItem("reperti-theme") : null;
    return cached || "light";
  });

  // Apply theme to <html> immediately
  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-theme", theme);
    if (typeof window !== "undefined") localStorage.setItem("reperti-theme", theme);
  }, [theme]);

  // On mount, fetch server-side preference (overrides if present)
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/settings");
        if (data?.theme && data.theme !== theme) {
          setThemeState(data.theme);
        }
      } catch (e) { console.warn("Theme: failed to fetch server preference", e); }
    })();
    // eslint-disable-next-line
  }, []);

  const setTheme = useCallback(async (next) => {
    setThemeState(next);
    try {
      await api.put("/settings", { theme: next });
    } catch (e) { console.warn("Theme: failed to persist preference", e); }
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
